var backbone = {exports: {}};

export { backbone as b };
